import firebase from 'firebase/app'  
import 'firebase/firestore' 
import "@firebase/auth"
import 'firebase/database'

var firebaseConfig = {
  apiKey: "AIzaSyA8U2w4RO5CLlUkdJkks51kUrwnJHqMVDo",
  authDomain: "crud-ae153.firebaseapp.com",
  databaseURL: "https://crud-ae153.firebaseio.com",
  projectId: "crud-ae153",
  storageBucket: "crud-ae153.appspot.com",
  messagingSenderId: "288652618661",
  appId: "1:288652618661:web:576b02d8e9771eea26564c"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);

export default firebaseApp.firestore()